import { render, staticRenderFns } from "./webhook-filter-manager.vue?vue&type=template&id=54f80f08"
import script from "./webhook-filter-manager.vue?vue&type=script&lang=js"
export * from "./webhook-filter-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports